export default __webpack_public_path__ + "static/media/victory.1d8ce878.svg";